import { render, staticRenderFns } from "./SiteEvents.vue?vue&type=template&id=0b8d1daa"
import script from "./SiteEvents.vue?vue&type=script&lang=js"
export * from "./SiteEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports